import {
  DeviceInfo,
  DeviceType,
  RoomDialWrf06,
  RoomSensorMastertherm,
  RoomSensorNovos3,
  RoomSensorRegin,
  RoomSensorWrf04,
  RoomSensorWrf06,
} from '../../../../shared/api-clients/_api';

export const deviceNameMapping = {
  [DeviceType.WRF04]: `Thermokon ${DeviceType.WRF04.toUpperCase()}`,
  [DeviceType.WRF06]: `Thermokon ${DeviceType.WRF06.toUpperCase()}`,
  [DeviceType.NOVOS3]: 'Thermokon Novos 3',
  [DeviceType.REGIN]: 'Regin CTHRC',
};
export const getDeviceName = (device: DeviceInfo) => deviceNameMapping[device.deviceType];

export const getDeviceWithZoneDescription = (
  device: RoomSensorMastertherm | RoomSensorWrf04 | RoomDialWrf06,
  getZoneDescription,
) => `${getDeviceName(device)} - ${getZoneDescription(device.params.install_location)}`;

export type SensorDevice = RoomSensorWrf04 | RoomSensorWrf06 | RoomSensorNovos3 | RoomSensorRegin;

export type ControlDevice = RoomDialWrf06;

export type ConfigurableDevices = SensorDevice | ControlDevice;

export const makeIdForDevice = ({ deviceType, params }: ConfigurableDevices) =>
  `${deviceType} - ${params.install_location}`;
